module.exports = __webpack_public_path__ + "5307f2059e4c3f98ee2b66577c82175b.png";